import React from 'react';
import PropTypes from 'prop-types';
import styles from './Month.module.scss';

const Month = ({children, disabled, shy, selected, toLeftSelection, toRightSelection, clickHandler}) => {

    const monthClasses = [styles.month];
    if (shy || disabled) monthClasses.push(styles.shy);
    if (disabled) monthClasses.push(styles.disabled);
    if (selected) monthClasses.push(styles.selected);
    if (toLeftSelection) monthClasses.push(styles.toLeftSelection);
    if (toRightSelection) monthClasses.push(styles.toRightSelection);

    const monthClickHandler = disabled ? () => null : clickHandler;

    return (
        <div className={styles.container}>
            <div className={styles.dummy}/>
            <div className={monthClasses.join(' ')} onClick={monthClickHandler}>
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </div>
    );
};

Month.propTypes = {
    children: PropTypes.any,
    disabled: PropTypes.bool,
    selected: PropTypes.bool,
    shy: PropTypes.bool,
    toLeftSelection: PropTypes.bool,
    toRightSelection: PropTypes.bool,
    clickHandler: PropTypes.func,
};

Month.defaultProps = {
    children: null,
    disabled: false,
    selected: false,
    shy: false,
    toLeftSelection: false,
    toRightSelection: false,
    clickHandler: () => null,
};

export default Month;
